import {
  CartogramLegendSettings,
  FeaturesLegends,
} from '@project/components/Module/Cartograms';
import { createPdf } from '@project/utils/createPdf';
import { Feature } from 'ol';
import { Content, ContentImage, ContentTable } from 'pdfmake/interfaces';

export class CartogramPdfManager {
  createLegendTable = (
    legendsSettings: CartogramLegendSettings[],
  ): ContentTable => ({
    table: {
      headerRows: 1,
      widths: [300, '*', '*', '*'],
      body: [
        ['Описание', 'Нач. значение', 'Кон. значение', 'Цвет'],
        ...legendsSettings.map(({ description, minValue, maxValue, color }) => [
          { text: description },
          { text: minValue },
          { text: maxValue },
          { text: null, fillColor: color },
        ]),
      ],
    },
  });

  createScheenshotSection = (image: string): ContentImage => {
    return { image, width: 500, alignment: 'center' };
  };

  createFeaturesTable = (
    features: Feature[],
    featuresLegends: FeaturesLegends,
    featureKey?: string,
  ): ContentTable => {
    const featuresTableBody = features.map((feature) => {
      const featureId = feature.getId();
      if (!featureId) throw Error('Feature id not provided');

      const legendSettings = featuresLegends[featureId];
      const featureKeyValue = featureKey
        ? (feature.get(featureKey) as string | undefined)
        : undefined;
      const featureComputedValue = legendSettings?.computeColumn
        ? (feature.get(legendSettings.computeColumn) as number | undefined)
        : undefined;

      return [
        featureKeyValue ?? featureId,
        featureComputedValue ?? 0,
        { text: '', fillColor: legendSettings?.legend.color },
      ];
    });

    return {
      table: {
        headerRows: 1,
        widths: [350, '*', '*'],
        body: [['Название', 'Значение', 'Цвет'], ...featuresTableBody],
      },
    };
  };

  createPdf = ({
    title,
    features,
    screenshot,
    featuresLegends,
    legendsSettings,
  }: {
    title: string;
    screenshot: string;
    features: Feature[];
    featuresLegends: FeaturesLegends;
    legendsSettings: CartogramLegendSettings[];
  }) => {
    const legendTable = this.createLegendTable(legendsSettings);
    const screenShotSection = this.createScheenshotSection(screenshot);
    const featuresTable = this.createFeaturesTable(
      features,
      featuresLegends,
      'name',
    );

    const documentContent: Content = [
      {
        text: title,
        style: 'documentTitle',
      },
      screenShotSection ?? [],
      { text: 'Легенда', style: 'title', pageBreak: 'before' },
      legendTable,
      { text: 'Список объектов', style: 'title' },
      featuresTable,
    ];

    return createPdf(documentContent, { info: { title: 'Картограммы' } });
  };
}
